import { Pipe, PipeTransform, inject } from '@angular/core';
import { Domain } from '@monsido/modules/models/api/domain';
import { SessionService } from '@monsido/core/session/session.service';

@Pipe({
    name: 'isStatsDemoData',
    standalone: true,
})
export class IsStatsDemoDataPipe implements PipeTransform {
    private readonly sessionService = inject(SessionService);

    transform (domain: Domain | null): boolean {
        const statistics = domain?.features?.statistics;
        const customer = this.sessionService.customer;
        const isDemo = customer !== null && customer.plan_type === 'demo';
        return !statistics && isDemo;
    }
}
